import React, { useEffect } from "react";
import Layout from "../../../components/layout/Layout";
import Table from "react-bootstrap/Table";
import { Button } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const TermsAndConditions = () => {
  const { t } = useTranslation();
  const workAgrementSwedish = `${blobURL}/Allmänt avtal för Egenanställning.pdf`;
  const workAgrementEnglish = `${blobURL}/General Contract for Self-Employment.pdf`;

  const language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout className="p-4 mt-5 invoice-space2 term-space" showSidebar bgcolor>
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/terms-and-conditions"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/villkor"
          />
        )}
      </Helmet>
      <div className="page-content">
        <div className="agreements Contracts">
          <div className="agreements-list">
            <h4 className="accident_ins font-weight-bold">
              {t("Terms and Conditions")}
            </h4>

            <p></p>
          </div>
        </div>
        <div className="w-100 agreemwnt-table">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>{t("Certificate no")}</th>
                <th>Pdf</th>
                <th>{t("Download")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ width: "460px" }}>1</td>
                <td> {t("Invozio Terms and Conditions")}</td>
                <td>
                  <Button
                    className="theme_btn"
                    href={
                      language === LOCALES.EN_US
                        ? workAgrementEnglish
                        : workAgrementSwedish
                    }
                    target="_blank"
                    // onClick={() => { download_file("/static/media/workAgrementSwedish.6db496b3a4daafe11a89.pdf", t("Terms and Conditions")); }}
                  >
                    <FiDownload className="cursor-pointer new_colr" size={20} />
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Layout>
  );
};

export default TermsAndConditions;
